/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Callout } from "@octopusdeploy/design-system-components";
import type { ServerConfigurationResource } from "@octopusdeploy/octopus-server-client";
import { repository } from "~/clientInstance";
import type { DataBaseComponentState } from "~/components/DataBaseComponent/DataBaseComponent";
import { DataBaseComponent } from "~/components/DataBaseComponent/DataBaseComponent";
import SaveDialogLayout from "~/components/DialogLayout/SaveDialogLayout";
import { Text } from "~/components/form";
interface EditServerConfigurationProps {
    onSaveDone(node: ServerConfigurationResource): void;
    isHighAvailability: boolean;
}
interface EditServerConfigurationState extends DataBaseComponentState {
    loaded: boolean;
    serverUri?: string;
}
export class EditServerConfiguration extends DataBaseComponent<EditServerConfigurationProps, EditServerConfigurationState> {
    constructor(props: EditServerConfigurationProps) {
        super(props);
        this.state = { loaded: false };
    }
    async componentDidMount() {
        return this.doBusyTask(async () => {
            const configuration = await repository.ServerConfiguration.get();
            this.setState({ serverUri: configuration.ServerUri, loaded: true });
        });
    }
    async save() {
        return this.doBusyTask(async () => {
            const configuration = await repository.ServerConfiguration.get();
            configuration.ServerUri = this.state.serverUri!;
            await repository.ServerConfiguration.modify(configuration);
            this.props.onSaveDone(configuration);
        });
    }
    render() {
        const body = this.state.loaded && this.renderBody();
        return (<SaveDialogLayout title="Edit Server Configuration" busy={this.state.busy} errors={this.errors} onSaveClick={() => this.save()}>
                {body}
            </SaveDialogLayout>);
    }
    renderBody() {
        return (<>
                {this.props.isHighAvailability && (<Callout title="Restart Required" type={"information"}>
                        In a multiple node cluster, updating these settings requires restarting your cluster.
                    </Callout>)}
                <Text label="Server Uri" placeholder="The publicly-accessible url of this server." value={this.state.serverUri!} onChange={(serverUri) => this.setState({ serverUri })} autoFocus={true} type="url"/>
            </>);
    }
    static displayName = "EditServerConfiguration";
}
